export default __webpack_public_path__ + "static/media/at.014b94b1.svg";